import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/leocatering.webp';
import screenshot_target from '../../../images/letterfunnel/petervanee.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Peter van Ee"
      firstname="Peter"
      companyname="Leo Catering"
      competition="Smaak Bedrijfscatering en Vitam"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/petervanee.js